/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cell_Inherited_DeniedInputs */



/**
* | output |
* | --- |
* | "Org default · denied" |
*
* @param {Rights_Cell_Inherited_DeniedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cell_inherited_denied = /** @type {((inputs?: Rights_Cell_Inherited_DeniedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cell_Inherited_DeniedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Org-Standard · verweigert")
	return /** @type {LocalizedString} */ ("Org default · denied")
});